export default __webpack_public_path__ + "static/media/dphns_small_thumbnail_website_5.80b7fc9c.jpg";